import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {withTranslation, WithTranslation} from 'react-i18next'
import SimpleTable, {CellData, ColumnCell, ColumnsSource, RowData, RowsDataSource, TableData} from './simple-table';
import {EmployeeReport, EmployeesReport} from '../stores/employee-report-store';

interface ProjectReportTableProps extends WithTranslation {
    data: EmployeesReport,
    onDownload?: (format: string) => Promise<boolean>,
    projectId: string,
}

interface ProjectReportTableState {
    data: EmployeesReport,
    isBusy: boolean,
    showConfirmModal: boolean,
}

class ProjectReportTable extends Component<ProjectReportTableProps, ProjectReportTableState> {
    constructor(props: ProjectReportTableProps) {
        super(props);
        this.state = {
            data: props.data,
            showConfirmModal: false,
            isBusy: false
        }
    }
    private parseTime(h:any, format?:any) {
        if (format == null) {
            var hours = parseFloat(h).toFixed(2)
            return `${hours} hrs`
        }
    }

    @autobind
    private buildTableData(projectTaskIdToName: Map<string, string>, reports: EmployeeReport[]): TableData {
        const { t } = this.props
        var self = this

        var projectIds: string[] = []
        var projectNames: string[] = []
        projectTaskIdToName.forEach((name, id) => {
            projectIds.push(id)
            projectNames.push(name)
        })

        var rowsDataSource: RowsDataSource = {
            title: "Employees",
            items: reports.map(report => { return { title: report.employeeName, cells: [], key: undefined } as RowData }),
            render: (cell: CellData) => { return <span className={'timesheet-item'} style={{ padding: 5 }}> {this.parseTime(cell.value)}</span> }
        }

        var columnsSource: ColumnsSource = {
            items: [],
            render: (columnCell) => { return <span style={{ padding: 5 }}> {columnCell.value} </span> }
        }

        var total = { title: t('Total'), cells: [], key: undefined } as RowData;
        projectIds.map((pid, index) => {
            reports.forEach((report, i) => {
                rowsDataSource.items[i].key = report.employeeId
                rowsDataSource.items[i].cells.push({ value: report.workedHoursPerTask.get(pid) ?? 0 })
                if (index == projectIds.length - 1) {
                    rowsDataSource.items[i].cells.push({ value: report.workedHoursPerProject.get(self.props.projectId) ?? 0 })
                    total.cells.push({ value: 0 })
                }
            })
            total.cells.push({ value: 0})
            columnsSource.items.push({
                key: pid,
                value: projectNames[index]
            } as ColumnCell)
        })
        columnsSource.items.push({ key: "1", value: t("Total") })

        rowsDataSource.items.forEach((row, index) => {
            for (var i = 0; i < row.cells.length; i++) {
                total.cells[i].value = (parseFloat(total.cells[i].value) + parseFloat(row.cells[i].value)).toFixed(2)
            }
        })

        rowsDataSource.items.push(total)
        return {
            columnsSource: columnsSource,
            rowsSource: rowsDataSource
        } as TableData
    }

    render() {
        let data = this.buildTableData(this.state.data.projectTaskIdToName, this.state.data.reports)
        return <SimpleTable data={data} onDownload={this.props.onDownload} downloadTypeStandard={"perTask-Standard"} downloadTypeMatrix={"perTask-Matrix"} />
    }
}
export default withTranslation()(ProjectReportTable);